import { LARGE } from "shared/utils/constants";
import { MaxWidth } from "shared/components/MaxWidth";
import { SrcSet } from "shared/components/SrcSet";
import styles from "./LogoSection.module.css";
import { Button } from "shared/components/Button";
import { TYPE_LINK } from "shared/utils/constants";
import cx from "classnames";

export const LogoSectionContainer = ({
  title,
  items,
  button,
  hasBorderTop,
  hasBorderBottom,
}) => {
  if (!title || !items?.length) return null;

  return (
    <MaxWidth size={LARGE}>
      <div
        className={cx(styles.container, {
          [styles.borderTop]: hasBorderTop,
          [styles.borderBottom]: hasBorderBottom,
        })}
      >
        <LogoSection
          title={title}
          items={items}
          button={button}
          hasBorderTop={hasBorderTop}
          hasBorderBottom={hasBorderBottom}
        />
      </div>
    </MaxWidth>
  );
};

export const LogoSection = ({ title, items, button }) => (
  <div className={styles.content}>
    {(title || button?.label) && (
      <header className={styles.header}>
        {title && <h2 className={styles.title}>{title}</h2>}
        {button && (
          <div className={styles.desktopButton}>
            <Button type={TYPE_LINK} {...button}>
              {button.label}
            </Button>
          </div>
        )}
      </header>
    )}
    {items && (
      <div className={styles.grid}>
        {items.map(({ name, url }) => (
          <div className={styles.item} key={name}>
            <SrcSet
              alt={name}
              sizes={[{ minWidth: 1, width: 240 }]}
              src={url}
            />
          </div>
        ))}
      </div>
    )}
    {Boolean(button?.label?.trim().length) && (
      <div className={styles.mobileButton}>
        <Button type={TYPE_LINK} {...button}>
          {button.label}
        </Button>
      </div>
    )}
  </div>
);
